import React from "react";
import { Pagination } from "@mui/material";

interface PaginationProps {
  pageCount: number;
  currentPage: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const CustomPagination = ({ pageCount, currentPage, onPageChange }: PaginationProps) => {
  return <Pagination count={pageCount} page={currentPage} onChange={onPageChange} color="primary" shape="rounded" />;
};

export default CustomPagination;
